import { types } from './checkbox.types';

export const checkYes = () => ({ type: types.CHECK_YES });

export const checkNo = () => ({ type: types.CHECK_NO });
